var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLeftSloganRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 10,
    y: 3,
    width: 500,
    height: 380,
    viewBox: "0 0 340.000000 250.000000",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "iconsvg-imagesvg",
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 60,
    height: 68.86261907494548,
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.1300048828125 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M68.14 39.78l2.11-1.22 2.8-1.62v-3.96l-2.2-1.27-5.79 3.36-21.33 12.36-22.77-13.19-4.52-2.62-2.36 1.36v3.96l2.8 1.62 24.18 14.03V82.6l2.5 1.44 2.5-1.44V52.58l22.08-12.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#184473",
    d: "M16.88 38.56l-2.8-1.62v30.08L41.06 82.6V52.59L16.88 38.56z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#184473",
    d: "M9.12 34.07l-2.28-1.32-.01.01L0 28.79V76.3L41.06 100V88.33L9.12 69.89V34.07z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#03b6f0",
    d: "M75.8 28.84l2.47-1.44 6.45-3.73L43.73 0 2.72 23.69l8.75 5.07 32.09-18.53L75.8 28.84z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#03b6f0",
    d: "M20.96 34.24l22.77 13.19 21.33-12.36 5.79-3.36-27.29-15.75-27.12 15.66 4.52 2.62z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0582d2",
    d: "M70.25 38.56l-2.11 1.22-22.08 12.8V82.6l26.99-15.58V36.94l-2.8 1.62z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0582d2",
    d: "M80.29 32.76l-.01-.01-2.27 1.32v35.82L46.06 88.33V100l41.07-23.71v-47.5l-6.84 3.97z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,20)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "tp-name iconsvg-namesvg"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.37-27.55L16.53-22.04 5.51-22.04 5.51-5.51 18.37-5.51 18.37 0 3.67 0Q0 0 0-3.67L0-3.67 0-23.88Q0-27.55 3.67-27.55L3.67-27.55 18.37-27.55ZM27.55 0L22.04 0 22.04-16.53Q22.04-20.2 25.71-20.2L25.71-20.2 36.72-20.2 34.88-14.69 27.55-14.69 27.55 0ZM60.63-20.2L60.61 3.67Q60.61 7.35 56.94 7.35L56.94 7.35 45.92 7.35 47.76 1.84 55.1 1.84 55.1 0 42.24 0Q38.57 0 38.57-3.67L38.57-3.67 38.57-20.2 44.08-20.2 44.08-5.51 55.1-5.51 55.1-20.2 60.63-20.2ZM64.29-16.53L64.29-16.53Q64.29-20.2 67.96-20.2L67.96-20.2 82.65-20.2Q86.33-20.2 86.33-16.53L86.33-16.53 86.33-3.67Q86.33 0 82.65 0L82.65 0 71.63 0 73.47-5.51 80.82-5.51 80.82-14.69 69.8-14.69 69.8 7.35 64.29 7.35 64.29-16.53ZM90-23.88L95.51-23.88 95.51-20.2 99.18-20.2 97.35-14.71 95.51-14.71 95.51-5.51 99.18-5.51 99.18 0 93.67 0Q90 0 90-3.67L90-3.67 90-23.88ZM102.86-3.67L102.86-16.53Q102.86-20.2 106.53-20.2L106.53-20.2 121.22-20.2Q124.9-20.2 124.9-16.53L124.9-16.53 124.9 0 119.39 0 119.37-14.69 108.37-14.69 108.37-5.51 117.55-5.51 115.71 0 106.55 0Q102.86 0 102.86-3.67L102.86-3.67ZM146.94-20.2L146.94-20.2Q150.61-20.2 150.61-16.53L150.61-16.53 150.61 3.67Q150.61 7.35 146.94 7.35L146.94 7.35 135.92 7.35 137.76 1.84 145.1 1.84 145.1-14.69 134.08-14.69 134.08-5.51 143.27-5.51 141.43 0 132.24 0Q128.57 0 128.57-3.67L128.57-3.67 128.57-16.53Q128.57-20.2 132.24-20.2L132.24-20.2 146.94-20.2ZM176.33-16.53L176.33-3.67Q176.33 0 172.65 0L172.65 0 157.96 0Q154.29 0 154.29-3.67L154.29-3.67 154.29-16.53Q154.29-20.2 157.96-20.2L157.96-20.2 172.65-20.2Q176.33-20.2 176.33-16.53L176.33-16.53ZM170.82-14.69L159.8-14.69 159.8-5.51 170.82-5.51 170.82-14.69Z",
    transform: "translate(0, 27.549999237060547)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLeftSloganRightBlack);
export default __webpack_public_path__ + "static/media/logo_left_slogan_right_black.415c8a9806d48b6b373176ef6adab622.svg";
export { ForwardRef as ReactComponent };